import React, { useState } from 'react';
import { Typography, Divider } from '@telus-uds/components-web';

import PdfActivityReport from './pdfActivity';
import EmailActivityReport from './emailActivity';
import OrderActivityReport from './orderActivity';
import CombinedActivityReport from './combinedActivity';
import BlackFridaySpecialReport from './blackFridaySpecial';
import DateRangeComparison from './dateRangeComparison';
import ApiRequestsReport from './apiRequests';
import ExportHistoryReport from './exportHistory';
import { isAdmin } from '../utils/request';

const BlackFridayReports = () => {
  const [tabSelected, setTabSelected] = useState('COMBINED');

  // API Activity and Export History are now admin-only on the backend (checkRoleAdmin) — reveal
  // other users' names/emails/export history with no per-role scoping dimension to apply. Hide
  // the tabs for every other role rather than let them land on a 401.
  const tabs = [
    { key: 'COMBINED', label: 'Dashboard' },
    { key: 'BLACK_FRIDAY', label: 'Black Friday Report' },
    { key: 'ORDER_ACTIVITY', label: 'Order Activity' },
    { key: 'PDF_ACTIVITY', label: 'PDF Reports' },
    { key: 'EMAIL_ACTIVITY', label: 'Email Reports' },
    { key: 'API_REQUESTS', label: 'API Activity', adminOnly: true },
    { key: 'COMPARISON', label: 'Compare Periods' },
    { key: 'EXPORT_HISTORY', label: 'Export History', adminOnly: true }
  ].filter(tab => !tab.adminOnly || isAdmin);


  const renderTabContent = () => {
    switch (tabSelected) {
      case 'PDF_ACTIVITY':
        return <PdfActivityReport />;
      case 'EMAIL_ACTIVITY':
        return <EmailActivityReport />;
      case 'ORDER_ACTIVITY':
        return <OrderActivityReport />;
      case 'COMBINED':
        return <CombinedActivityReport />;
      case 'BLACK_FRIDAY':
        return <BlackFridaySpecialReport />;
      case 'COMPARISON':
        return <DateRangeComparison />;
      case 'API_REQUESTS':
        return <ApiRequestsReport />;
      case 'EXPORT_HISTORY':
        return <ExportHistoryReport />;
      default:
        return <CombinedActivityReport />;
    }
  };

  return (
    <div className="container 85%" style={{ padding: '2rem' }}>
      <Typography heading="h2" variant={{ size: 'h2' }} block>Black Friday Reports & Analytics</Typography>
      <div
        style={{
          marginTop: '2rem',
          borderBottom: '1px solid #e4e4e4',
          padding: '0 2rem'
        }}
      >
        <ul
          style={{
            display: 'flex',
            gap: '1rem',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            listStyle: 'none',
            margin: 0,
            padding: 0
          }}
        >
          {tabs.map(tab => (
            <li
              key={tab.key}
              role="tab"
              tabIndex={0}
              aria-selected={tabSelected === tab.key}
              style={{
                padding: '1rem 1.5rem',
                borderRadius: '6px 6px 0 0',
                background: tabSelected === tab.key ? '#4b286d' : '#ffffff',
                borderTop:
                  tabSelected === tab.key
                    ? '2px solid #4b286d'
                    : '1px solid #e4e4e4',
                borderLeft:
                  tabSelected === tab.key
                    ? '2px solid #4b286d'
                    : '1px solid #e4e4e4',
                borderRight:
                  tabSelected === tab.key
                    ? '2px solid #4b286d'
                    : '1px solid #e4e4e4',
                borderBottom: 0,
                color: tabSelected === tab.key ? '#ffffff' : '#454545',
                fontWeight: tabSelected === tab.key ? '500' : '400',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flexShrink: 0,
                whiteSpace: 'nowrap'
              }}
              onClick={() => setTabSelected(tab.key)}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setTabSelected(tab.key);
                }
              }}
            >
              {tab.label}
            </li>
          ))}
        </ul>
      </div>
      <Divider />
      <div style={{ padding: '2rem 0' }}>{renderTabContent()}</div>
    </div>
  );
};

export default BlackFridayReports;
